import {z} from 'zod'

// Zod 4 removed `.safe()`; spell out the safe-integer ceiling it enforced (`.positive()`
// already covers the lower bound).
export const id = z.number().positive().max(Number.MAX_SAFE_INTEGER)

// Zod 4 moved string-format checks to top-level factories: `z.string().email()` -> `z.email()`.
export const email = z.email().transform((value) => value.toLowerCase())

export function oneOfEnum<TEnum extends string>(values: TEnum[]) {
    // Zod 4's `z.enum` takes a plain array; the old `[v[0], ...v.slice(1)]` tuple cast is unnecessary.
    return z.enum(values)
}

export const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
export const MAX_IMAGE_SIZE = 25_000_000
export const validImage = z
    .instanceof(File, {message: 'Required'})
    .refine((file) => file.size <= MAX_IMAGE_SIZE, `Max image size is 25MB.`)
    .refine(
        (file) => validImageTypes.includes(file.type),
        'Only .jpg, .jpeg, .png and .webp formats are supported.',
    )
